module.exports = __webpack_public_path__ + "img/resources.839315ab.svg";